import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { StyledMarkdown } from "components/shared/styled-markdown/styled-markdown";
import { CaseStudies } from "data/models";

interface CatalogueEntryCaseStudiesProps {
  caseStudies?: CaseStudies[];
}

export const CatalogueEntryCaseStudies = ({
  caseStudies,
}: CatalogueEntryCaseStudiesProps) => {
  if (!caseStudies || caseStudies.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Use Cases</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid divide-y divide-border sm:grid-cols-2 sm:divide-x sm:divide-y-0">
          {caseStudies.map((c, i) => (
            <div
              key={i}
              className="flex flex-col gap-2 py-4 first:pt-0 last:pb-0 sm:px-6 sm:py-0 sm:first:pl-0 sm:last:pr-0"
            >
              <h3 className="text-sm font-semibold">{c.title}</h3>
              <div className="text-sm text-muted-foreground [&_p]:m-0">
                <StyledMarkdown>{c.description}</StyledMarkdown>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};
